module.exports = __webpack_public_path__ + "static/silver-127574cc1beee66e1b90b4c84e8dce10.png";